import React from 'react';

import { Animation } from '../common/Container.jsx';
import { ImageBlockV1, ImageBlockV2 } from '../common/Image.jsx';

// region IMAGE V1 (-- DEPRECATED Use `ImageV2` --)

function ImageV1Component(props) {
    const imageProps = {};
    if (props.blockConfig && props.blockConfig.block) {
        if (props.blockConfig.block.image && props.blockConfig.block.image.id && props.blockConfig.block.image.extension) {
            imageProps.image = props.blockConfig.block.image;
            imageProps.imageId = imageProps.image.id;
        }
        imageProps.altText = props.blockConfig.block.altText;
        imageProps.link = props.blockConfig.block.url;
        imageProps.newWindow = props.blockConfig.block.newWindow;
    }
    return (
        <ImageBlockV1.Component
            {...props}
            {...imageProps}
            className="image__block"
            transform="c_fit" />
    );
}
const ImageV1 = { Component: ImageV1Component };

// region IMAGE V2

function ImageV2Component(props) {
    let animation, style;
    const imageProps = {};
    if (props.blockConfig && props.blockConfig.block) {
        animation = props.blockConfig.block.animation;
        if (props.blockConfig.block.image && props.blockConfig.block.image.id && props.blockConfig.block.image.extension) {
            imageProps.image = props.blockConfig.block.image;
            imageProps.imageId = imageProps.image.id;
        }
        imageProps.alt = props.blockConfig.block.altText;
        imageProps.link = props.blockConfig.block.url;
        imageProps.newWindow = props.blockConfig.block.newWindow;

        if (props.blockConfig.block.borderRadius && props.blockConfig.block.borderRadius.value && props.blockConfig.block.borderRadius.value.length > 0) {
            style = { borderRadius: `${props.blockConfig.block.borderRadius.value}${props.blockConfig.block.borderRadius.unit}` };
        }
    }
    let content = (
        <ImageBlockV2.Component
            {...props}
            {...imageProps}
            className="image__block"
            imageStyle={style}
            transform="c_fit" />
    );
    switch (animation) {
        case '1':
            content = <Animation builder={props.builder}>{content}</Animation>
            break;
    }
    return content;
}
const ImageV2 = { Component: ImageV2Component };

export {
    ImageV2,

    // DEPRECATED
    ImageV1
}